// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function once(fn) {
  var called = false;
  var result;
  return function () {
    if (!called) {
      result = fn.apply(void 0, arguments);
      called = true;
    }
    return result;
  };
}